module.exports = __webpack_public_path__ + "static/media/07.4313a563.png";